import { gql } from '@apollo/client'

const UPDATE_FOOD_MOOD_IMAGE_DETAILS_MUTATION = gql`
  mutation updateFoodMoodImageDetails(
    $id: ID!
    $data: FoodMoodImageDetailsInput!
  ) {
    updateFoodMoodImageDetails(id: $id, data: $data) {
      id
      updatedAt

      updatedBy {
        id
        name
      }

      imageUrl
    }
  }
`

export default UPDATE_FOOD_MOOD_IMAGE_DETAILS_MUTATION
